if (!customElements.get('contact-form')) {
  customElements.define(
    'contact-form',
    class ContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.summary = this.querySelector('[data-summary]');
        if (!this.form) return;

        this.fields = [...this.form.querySelectorAll('[data-validate]')];
        this.fields.forEach((field) => {
          field.addEventListener('input', () => {
            field.dataset.dirty = 'true';
            if (field.getAttribute('aria-invalid') === 'true') this.validate(field);
          });
          field.addEventListener('change', () => this.validate(field));
          field.addEventListener('blur', () => {
            if (field.dataset.dirty) this.validate(field);
          });
        });

        this.form.addEventListener('submit', (event) => {
          const invalid = this.fields.filter((field) => !this.validate(field));
          if (!invalid.length) return;
          event.preventDefault();
          if (this.summary) this.showSummary(invalid);
          else invalid[0].focus();
        });
      }

      validate(field) {
        const message = document.getElementById(field.dataset.validate);
        const valid = field.checkValidity();
        if (valid) {
          field.removeAttribute('aria-invalid');
          field.removeAttribute('aria-describedby');
        } else {
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', message.id);
        }
        message.hidden = valid;
        return valid;
      }

      showSummary(invalid) {
        const template = invalid.length === 1 ? this.dataset.summaryOne : this.dataset.summaryOther;
        const [before, after] = template.replace('[number]', invalid.length).split('[fields]');
        const names = invalid.map((field) => field.labels[0].textContent.trim());
        const parts = new Intl.ListFormat(document.documentElement.lang || 'de', { type: 'conjunction' }).formatToParts(names);

        let index = 0;
        const nodes = parts.map((part) => {
          if (part.type === 'literal') return part.value;
          const link = document.createElement('a');
          link.href = `#${invalid[index++].id}`;
          link.textContent = part.value;
          return link;
        });

        this.summary.querySelector('[data-summary-text]').replaceChildren(before, ...nodes, after);
        this.summary.hidden = false;
        this.summary.focus();
      }
    }
  );
}
